<template>
  <div class="page__shopee-marketing a-page">
    <div style="background-color:white; padding:10px; border-radius: 4px; overflow: hidden; position: relative;">
      <el-row style="margin-bottom: 10px">
        <el-col :sm="12" style="display: flex; gap: 10px">
          <shop-select v-model="shopee_shop.selected" :shopee_shop_list="shopee_shop.list"
                       :disabled="current_component !== 'list' || campaign_component !== 'list'"></shop-select>
          <template v-if="shopee_shop.selected">
            <el-button :type="is_connected_ads_platform ? 'soft-grey' : 'danger'" size="small" icon="el-icon-setting"
                       style="max-height: 33px;" @click="show_dialog.surge_setting = true">
            </el-button>

            <div
              style="display: flex; align-items: center; border-radius: 6px; padding: 0 10px; gap: 15px; margin-left: 10px">
              <span style="font-size: 13px;">{{ $t('ads.ads_credit') }}:</span>
              <strong style="color: orangered; font-size: 14px">{{ balance | currency }} {{ m__currency() }}</strong>
            </div>
          </template>
        </el-col>
        <el-col :sm="12" class="text-right" style="padding-top: 3px">
          <a href="https://atosa.asia/huong-dan-atosa/duy-tri-vi-tri-quang-cao-dau-thau-tu-khoa-shopee/"
             class="text-primary" style="font-size: 13px; font-weight: 600" target="_blank">
            <i class="el-icon-question"></i> {{ $t('ads.ads_guide') }}</a>
        </el-col>
      </el-row>

      <div v-if="campaign_component === 'list' && allow_show_alert" style="display: flex; flex-direction: column;">
        <div
          v-if="shopee_shop.selected && m__check_atosa_agent_used_package().result === true && $store.state.userInfo.store_current_money < min_atosa_balance">
          <div
            style="margin-top: 25px; display: flex; background-color: #fdf6ec; border-color: #d9ecff; padding: 10px; border-radius: 4px; font-weight: bold">
            <div style="width: 20px">
              <i class="el-icon-info"></i>
            </div>
            <div style="flex: 1; font-size: 13px">
              {{ $t('ads.atosa_balance_running_low') }}
              <a href="https://banhang.atosa.asia/payment/transfer" target="_blank" style="font-size: 13px">
                {{ $t('ads.atosa_balance_running_low_recharge') }}
              </a>
            </div>
            <div style="width: 20px; display: flex; justify-content: right">
              <i class="el-icon-close" style="font-size: 13px !important; cursor: pointer"></i>
            </div>
          </div>
        </div>

        <template v-if="false">
          <div
            v-if="shopee_shop.selected && m__has_agent() && m__check_atosa_agent_used_package().result === false">
            <div
              style="margin-top: 25px; display: flex; background-color: #fdf6ec; border-color: #d9ecff; padding: 10px; border-radius: 4px; font-weight: bold">
              <div style="width: 20px">
                <i class="el-icon-info"></i>
              </div>
              <div style="flex: 1; font-size: 13px">
                Gói sản phẩm Atosa Agent AI của bạn chưa được kích hoạt hoặc đã hết hạn. Vui lòng gia hạn gói sản phẩm
                để
                tiếp tục sử dụng.
                <a href="javascript:void(0)" style="font-size: 13px" @click="m__redirect_to_buy_atosa_agent()">
                  👉 Gia hạn gói tại đây.
                </a>
              </div>
              <div style="width: 20px; display: flex; justify-content: right">
                <i class="el-icon-close" style="font-size: 13px !important; cursor: pointer"></i>
              </div>
            </div>
          </div>
          <div
            v-if="shopee_shop.selected && m__has_agent() && m__check_atosa_agent_used_package().about_to_expired">
            <div
              style="margin-top: 25px; display: flex; background-color: #fdf6ec; border-color: #d9ecff; padding: 10px; border-radius: 4px; font-weight: bold">
              <div style="width: 20px">
                <i class="el-icon-info"></i>
              </div>
              <div style="flex: 1; font-size: 13px">
                Gói sản phẩm Atosa Agent AI của bạn sẽ hết hạn vào ngày
                {{ m__check_atosa_agent_used_package().expired_at }}. Vui lòng gia hạn gói sản phẩm để tiếp tục sử dụng.
                <a href="javascript:void(0)" style="font-size: 13px" @click="m__redirect_to_buy_atosa_agent()">
                  👉 Gia hạn gói tại đây.
                </a>
              </div>
              <div style="width: 20px; display: flex; justify-content: right">
                <i class="el-icon-close" style="font-size: 13px !important; cursor: pointer"></i>
              </div>
            </div>
          </div>
        </template>

        <div
          v-if="shopee_shop.selected && m__check_is_unpaid_operating_cost()">
          <div
            style="margin-top: 25px; display: flex; background-color: #fdf6ec; border-color: #d9ecff; padding: 10px; border-radius: 4px; font-weight: bold">
            <div style="width: 20px">
              <i class="el-icon-info"></i>
            </div>
            <div style="flex: 1; font-size: 13px">
              Bạn đang có {{ atosa_agent_unpaid.total }} giao dịch chưa được thanh toán trên Atosa Agent AI từ
              ngày {{ timeFormat(atosa_agent_unpaid.last_document_time, 'DD/MM/YYYY') }} với tổng chi phí vận hành là
              {{ m__calculate(atosa_agent_unpaid.total_unpaid_cost) | currency }}.
              Các cấu hình hiện đang tạm dừng, vui lòng thanh toán để tiếp tục sử dụng tính năng.
              <a href="javascript:void(0)" style="font-size: 13px" @click="m__confirm_charge_unpaid_operating_cost()">
                👉 Thanh toán ngay
              </a>
            </div>
            <div style="width: 20px; display: flex; justify-content: right">
              <i class="el-icon-close" style="font-size: 13px !important; cursor: pointer"></i>
            </div>
          </div>
        </div>
      </div>

      <div v-if="current_component !== 'create'" style="margin-top: 40px">
        <div>
          <div v-if="campaign_component === 'list'" style="display: flex;">
            <div style="flex: auto">
              <el-tabs v-model="current_tab" class="el-tab-divided-last">
                <el-tab-pane :label="$t('ads.atosa_ads')" name="new_cpc_homepage_group" :disabled="getting_campaigns">
                </el-tab-pane>
                <el-tab-pane :label="$t('ads.all_cpc_ads')" name="new_cpc_homepage"
                             :disabled="getting_campaigns">
                </el-tab-pane>
                <el-tab-pane :label="$t('ads.product_ads')" name="product_homepage" :disabled="getting_campaigns">
                </el-tab-pane>
                <el-tab-pane :label="$t('ads.shop_ads')" name="shop_homepage" :disabled="getting_campaigns">
                </el-tab-pane>
                <el-tab-pane :label="$t('ads.live_stream')" name="live_stream_homepage"
                             :disabled="getting_campaigns">
                </el-tab-pane>
              </el-tabs>
            </div>
          </div>

          <PasCampaignComponent :key="component_key"
                                :campaign_type="current_tab.replace('_group', '')"
                                :shop="shop"
                                :shopee_shop="shopee_shop"
                                :sp_user="sp_user"
                                :date_range="date_range"
                                :start_date="start_date"
                                :end_date="end_date"
                                :campaign_component.sync="campaign_component"
                                :select_hour="show_dialog.select_hour"
                                :hour_mode.sync="hour_mode"
                                :agency_files="agency_files"
                                :agency_file_id_selected="agency_file_id_selected"
                                :is_group="current_tab.includes('_group')"
                                :parent_is_compare_campaign.sync="is_compare_campaign"
                                :parent_compare_date_range.sync="compare_date_range"
                                :ads_config="ads_config"
                                :ads_data="ads_data"
                                :non_ads_data="non_ads_data"
                                :product_list="product_list"
                                :getting_campaigns.sync="getting_campaigns"
                                :cascader_options="cascader_options"
                                :is_full="true"
                                :fff="fff"
                                :active_campaign_list.sync="active_campaign_list"
                                :filter_clone.sync="filter_clone"
                                :welcome_atosa_agent_showed_dialog.sync="welcome_atosa_agent_showed_dialog">
            <div slot="datetime">
              <el-row>
                <el-col :sm="7" style="padding-right: 20px">
                  <el-date-picker
                    class="full-w" v-model="date_range" type="daterange" range-separator="-"
                    :start-placeholder="$t('base.start_time')" :end-placeholder="$t('base.end_time')" size="mini"
                    format="dd-MM-yyyy" :clearable="false"
                    :disabled="current_component === 'create'"
                    @change="m__change_date" :picker-options="picker_options">
                  </el-date-picker>
                </el-col>
                <template v-if="campaign_component === 'list'">
                  <el-col :sm="8" style="padding-right: 10px; display: flex; gap: 20px">
                    <template v-if="c__has_advanced_ads">
                      <el-button size="mini" :type="hour_mode ? 'success' : 'primary'" icon="el-icon-time"
                                 :disabled="current_component !== 'list'" @click="m__show_select_hour_dialog">
                        {{ hour_mode ? $t('ads.viewing_data_by_hour') : $t('ads.view_data_by_hour') }}
                      </el-button>
                    </template>
                    <template v-else>&nbsp;</template>

                    <template v-if="false && has_agency_plan()">
                      <el-select size="mini" v-model="agency_file_id_selected" style="width: 200px"
                                 :disabled="loading.get_campaigns" :placeholder="$t('base.select_plan_file')" clearable>
                        <el-option v-for="file in agency_files.filter(i => i.shopId === shopee_shop.selected)"
                                   :key="file.id"
                                   :value="file.id" :label="file.filename"></el-option>
                      </el-select>
                    </template>
                    <template v-else>&nbsp;</template>
                  </el-col>

                  <el-col :sm="9" class="text-right">
                    <el-button
                      size="mini" type="primary"
                      :disabled="getting_campaigns"
                      :loading="loading.add_campaign_type"
                      icon="el-icon-plus" @click="m__select_add_campaign_type">
                      {{ $t('ads.create_new_campaign') }}
                    </el-button>
                  </el-col>
                </template>
              </el-row>
            </div>
          </PasCampaignComponent>
        </div>
      </div>

      <div v-if="current_component === 'create'">
        <CreateProductComponent v-if="add_campaign_type === 'product'"
                                :product_list="product_list"
                                :shop="shop"
                                :sp_user="sp_user"
                                :get_products="loading.get_products"
                                :ads_config="ads_config"
                                :ads_data="ads_data"
                                :non_ads_data="non_ads_data"
                                :selected_product_ids="selected_product_ids"
                                :cascader_options="cascader_options"
                                :fff="fff"
                                :active_campaign_list="active_campaign_list"
                                @reload_products="m__get_shop_product_list(false)"
                                @back_to_list="m__on_back_to_list"></CreateProductComponent>


        <CreateShopComponent v-if="add_campaign_type === 'shop'"
                             :product_list="product_list"
                             :shop="shop"
                             :sp_user="sp_user"
                             :get_products="loading.get_products"
                             :ads_config="ads_config"
                             :fff="fff"
                             @back_to_list="m__on_back_to_list"></CreateShopComponent>

        <CreateLiveStreamComponent v-if="add_campaign_type === 'live_stream'"
                                   :shop="shop"
                                   :sp_user="sp_user"
                                   :ads_config="ads_config"
                                   :ads_data="ads_data"
                                   :non_ads_data="non_ads_data"
                                   @back_to_list="m__on_back_to_list"></CreateLiveStreamComponent>
      </div>

      <div
        v-if="false && shopee_shop.selected && atosa_ai_fixed_list.some(i => $store.state.userInfo.username.includes(i))">
        <button class="chatbot-button" @click="show_dialog.chatbot = true">
          💬 &nbsp;Chat với trợ lý Atosa
        </button>
      </div>
    </div>

    <el-dialog :visible.sync="show_dialog.add_campaign_type" :close-on-click-modal="false"
               :width="'1000px'">
      <div slot="title" style="padding:10px 15px">
        <strong style="font-size: 16px">{{ $t('ads.select_ads_type') }}</strong>

        <div style="margin-top: 30px" class="flex gap-[20px]">
          <div class="flex-1">
            <div :class="add_campaign_type === 'product' ? 'card-fixed-active' : 'card-fixed'"
                 @click="add_campaign_type = 'product'">
              <div>
                <el-card :shadow="add_campaign_type === 'product' ? 'always' : 'never'">
                  <div>
                    <svg viewBox="0 0 256 160" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <rect width="256" height="160" rx="4" fill="white"></rect>
                      <g clip-path="url(#clip0_4397_194738)">
                        <path d="M83 47C83 42.5817 86.5817 39 91 39H165C169.418 39 173 42.5817 173 47V136H83V47Z"
                              fill="#FAFAFA"></path>
                        <rect x="89.25" y="47.25" width="77.5" height="11.5" rx="1.75" fill="white"></rect>
                        <rect x="89.25" y="47.25" width="77.5" height="11.5" rx="1.75" stroke="#D8D8D8"
                              stroke-width="0.5"></rect>
                        <path fill-rule="evenodd" clip-rule="evenodd"
                              d="M160.497 49.4971C162.154 49.4971 163.497 50.8402 163.497 52.4971C163.497 53.2347 163.231 53.9101 162.789 54.4325L164.429 56.0718C164.526 56.1694 164.526 56.3277 164.429 56.4253C164.342 56.5121 164.207 56.5218 164.11 56.4543L164.075 56.4253L162.436 54.7864C161.913 55.2297 161.236 55.4971 160.497 55.4971C158.84 55.4971 157.497 54.1539 157.497 52.4971C157.497 50.8402 158.84 49.4971 160.497 49.4971ZM160.497 49.9971C159.116 49.9971 157.997 51.1164 157.997 52.4971C157.997 53.8778 159.116 54.9971 160.497 54.9971C161.878 54.9971 162.997 53.8778 162.997 52.4971C162.997 51.1164 161.878 49.9971 160.497 49.9971Z"
                              fill="#999999"></path>
                        <rect x="89.25" y="63.25" width="36.5" height="49.5" rx="1.75" fill="white"></rect>
                        <rect x="89.25" y="63.25" width="36.5" height="49.5" rx="1.75" stroke="#D8D8D8"
                              stroke-width="0.5"></rect>
                        <path
                          d="M89.25 95.25H125.75V111C125.75 111.966 124.966 112.75 124 112.75H91C90.0335 112.75 89.25 111.966 89.25 111V95.25Z"
                          fill="#FAFAFA"></path>
                        <path
                          d="M89.25 95.25H125.75V111C125.75 111.966 124.966 112.75 124 112.75H91C90.0335 112.75 89.25 111.966 89.25 111V95.25Z"
                          stroke="#D8D8D8" stroke-width="0.5"></path>
                        <rect x="92" y="98" width="31" height="4" rx="1" fill="#EEEEEE"></rect>
                        <rect x="92" y="105" width="17" height="4" rx="1" fill="#EEEEEE"></rect>
                        <rect x="130.25" y="63.25" width="36.5" height="49.5" rx="1.75" fill="white"></rect>
                        <rect x="130.25" y="63.25" width="36.5" height="49.5" rx="1.75" stroke="#D8D8D8"
                              stroke-width="0.5"></rect>
                        <path
                          d="M130.25 95.25H166.75V111C166.75 111.966 165.966 112.75 165 112.75H132C131.034 112.75 130.25 111.966 130.25 111V95.25Z"
                          fill="#FAFAFA"></path>
                        <path
                          d="M130.25 95.25H166.75V111C166.75 111.966 165.966 112.75 165 112.75H132C131.034 112.75 130.25 111.966 130.25 111V95.25Z"
                          stroke="#D8D8D8" stroke-width="0.5"></path>
                        <rect x="133" y="98" width="31" height="4" rx="1" fill="#EEEEEE"></rect>
                        <rect x="133" y="105" width="24" height="4" rx="1" fill="#EEEEEE"></rect>
                        <rect x="89.25" y="117.25" width="36.5" height="49.5" rx="1.75" fill="white"></rect>
                        <rect x="89.25" y="117.25" width="36.5" height="49.5" rx="1.75" stroke="#D8D8D8"
                              stroke-width="0.5"></rect>
                        <rect x="130.25" y="117.25" width="36.5" height="49.5" rx="1.75" fill="white"></rect>
                        <rect x="130.25" y="117.25" width="36.5" height="49.5" rx="1.75" stroke="#D8D8D8"
                              stroke-width="0.5"></rect>
                      </g>
                      <path
                        d="M83.25 47C83.25 42.7198 86.7198 39.25 91 39.25H165C169.28 39.25 172.75 42.7198 172.75 47V135.75H83.25V47Z"
                        stroke="#D8D8D8" stroke-width="0.5"></path>
                      <g filter="url(#filter0_dd_4397_194738)">
                        <g clip-path="url(#clip1_4397_194738)">
                          <rect x="76" y="55" width="50" height="75" rx="4" fill="white"></rect>
                          <path
                            d="M107.046 73.3958L106.989 69.3028C106.989 69.3028 104.937 71.4949 101.989 71.4949C99.0402 71.4949 96.9995 69.3027 96.9995 69.3027L97.1335 73.4191C97.1423 73.6887 97.3635 73.9028 97.6333 73.9028H106.546C106.825 73.9028 107.05 73.6747 107.046 73.3958Z"
                            fill="#F59680"></path>
                          <path
                            d="M88.7094 74.4491L96.5367 69.4809C96.8346 69.2918 97.2465 69.4587 97.3775 69.7863C97.8136 70.8775 99.0191 72.8614 102.019 72.8614C105.038 72.8614 106.235 70.8529 106.661 69.7662C106.788 69.4433 107.187 69.2737 107.485 69.4505L115.924 74.4509C116.121 74.5677 116.214 74.8035 116.149 75.0231L114.727 79.8202C114.647 80.0917 114.357 80.2423 114.089 80.1522L110.146 78.8284C109.8 78.7124 109.451 78.9936 109.49 79.3562L110.863 92.0607C110.878 92.2016 110.832 92.3409 110.718 92.4251C110.172 92.8281 108.147 93.9473 102.441 93.9984C96.7054 94.0498 94.4135 92.8528 93.7829 92.4285C93.6546 92.3422 93.5975 92.192 93.6124 92.0382L94.8273 79.5006C94.862 79.1425 94.5185 78.8661 94.1761 78.9765L90.5119 80.1585C90.243 80.2453 89.9557 80.0922 89.8778 79.8206L88.4968 75.0092C88.4356 74.796 88.5222 74.5679 88.7094 74.4491Z"
                            fill="#FFBDB0"></path>
                          <path
                            d="M104.477 76.0986H107.944V78.9847C107.944 79.537 107.496 79.9847 106.944 79.9847H105.477C104.924 79.9847 104.477 79.537 104.477 78.9847V76.0986Z"
                            fill="#F59680"></path>
                          <rect width="50" height="25" transform="translate(76 105)" fill="#FEECE1"></rect>
                          <rect x="80" y="108" width="42" height="3" rx="1" fill="white"></rect>
                          <rect x="80" y="113" width="32" height="3" rx="1" fill="white"></rect>
                          <rect opacity="0.8" x="80" y="118" width="32" height="6" rx="1" fill="#EE4D2D"
                                fill-opacity="0.2"></rect>
                        </g>
                        <rect x="76.5" y="55.5" width="49" height="74" rx="3.5" stroke="#EE4D2D"></rect>
                      </g>
                      <defs>
                        <filter id="filter0_dd_4397_194738" x="60" y="39" width="82" height="115"
                                filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                          <feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood>
                          <feColorMatrix in="SourceAlpha" type="matrix"
                                         values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                         result="hardAlpha"></feColorMatrix>
                          <feOffset dy="8"></feOffset>
                          <feGaussianBlur stdDeviation="8"></feGaussianBlur>
                          <feColorMatrix type="matrix"
                                         values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"></feColorMatrix>
                          <feBlend mode="normal" in2="BackgroundImageFix"
                                   result="effect1_dropShadow_4397_194738"></feBlend>
                          <feColorMatrix in="SourceAlpha" type="matrix"
                                         values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                         result="hardAlpha"></feColorMatrix>
                          <feOffset></feOffset>
                          <feGaussianBlur stdDeviation="8"></feGaussianBlur>
                          <feColorMatrix type="matrix"
                                         values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"></feColorMatrix>
                          <feBlend mode="normal" in2="effect1_dropShadow_4397_194738"
                                   result="effect2_dropShadow_4397_194738"></feBlend>
                          <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_4397_194738"
                                   result="shape"></feBlend>
                        </filter>
                        <clipPath id="clip0_4397_194738">
                          <path d="M83 47C83 42.5817 86.5817 39 91 39H165C169.418 39 173 42.5817 173 47V136H83V47Z"
                                fill="white"></path>
                        </clipPath>
                        <clipPath id="clip1_4397_194738">
                          <rect x="76" y="55" width="50" height="75" rx="4" fill="white"></rect>
                        </clipPath>
                      </defs>
                    </svg>
                  </div>

                  <div class="mt-[30px] text-center">
                    <strong class="text-[18px]">{{ $t('ads.product_ads') }}</strong>
                  </div>
                  <div class="mt-[10px] h-[60px] text-center">
                    <span class="text-[13px] text-[#666]">
                      Hiển thị sản phẩm đến người mua tìm kiếm từ khóa liên quan hoặc xem các sản phẩm tương tự.
                    </span>
                  </div>
                </el-card>
              </div>
            </div>
          </div>
          <div class="flex-1">
            <div style="position: relative"
                 :style="{cursor: (ads_data && ads_data.ads_toggle && ads_data.ads_toggle.enable_shop_ads_v2) ? 'pointer' : 'not-allowed'}"
                 :class="add_campaign_type === 'shop' ? 'card-fixed-active' : 'card-fixed'"
                 @click="(ads_data && ads_data.ads_toggle && ads_data.ads_toggle.enable_shop_ads_v2) && (add_campaign_type = 'shop')">
              <el-card :shadow="add_campaign_type === 'shop' ? 'always' : 'never'">
                <div>
                  <svg viewBox="0 0 256 160" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect width="256" height="160" rx="4" fill="white"></rect>
                    <g clip-path="url(#clip0_4397_195125)">
                      <path d="M83 47C83 42.5817 86.5817 39 91 39H165C169.418 39 173 42.5817 173 47V136H83V47Z"
                            fill="#FAFAFA"></path>
                      <rect x="89.25" y="47.25" width="77.5" height="11.5" rx="1.75" fill="white"></rect>
                      <rect x="89.25" y="47.25" width="77.5" height="11.5" rx="1.75" stroke="#D8D8D8"
                            stroke-width="0.5"></rect>
                      <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M160.497 49.4971C162.154 49.4971 163.497 50.8402 163.497 52.4971C163.497 53.2347 163.231 53.9101 162.789 54.4325L164.429 56.0718C164.526 56.1694 164.526 56.3277 164.429 56.4253C164.342 56.5121 164.207 56.5218 164.11 56.4543L164.075 56.4253L162.436 54.7864C161.913 55.2297 161.236 55.4971 160.497 55.4971C158.84 55.4971 157.497 54.1539 157.497 52.4971C157.497 50.8402 158.84 49.4971 160.497 49.4971ZM160.497 49.9971C159.116 49.9971 157.997 51.1164 157.997 52.4971C157.997 53.8778 159.116 54.9971 160.497 54.9971C161.878 54.9971 162.997 53.8778 162.997 52.4971C162.997 51.1164 161.878 49.9971 160.497 49.9971Z"
                            fill="#999999"></path>
                      <rect x="89.25" y="63.25" width="77.5" height="21.5" rx="1.75" fill="white"></rect>
                      <rect x="89.25" y="63.25" width="77.5" height="21.5" rx="1.75" stroke="#D8D8D8"
                            stroke-width="0.5"></rect>
                      <rect x="94" y="69" width="11" height="11" rx="5.5" fill="#EEEEEE"></rect>
                      <rect x="89.25" y="89.25" width="36.5" height="49.5" rx="1.75" fill="white"></rect>
                      <rect x="89.25" y="89.25" width="36.5" height="49.5" rx="1.75" stroke="#D8D8D8"
                            stroke-width="0.5"></rect>
                      <path
                        d="M89.25 121.25H125.75V137C125.75 137.966 124.966 138.75 124 138.75H91C90.0335 138.75 89.25 137.966 89.25 137V121.25Z"
                        fill="#FAFAFA"></path>
                      <path
                        d="M89.25 121.25H125.75V137C125.75 137.966 124.966 138.75 124 138.75H91C90.0335 138.75 89.25 137.966 89.25 137V121.25Z"
                        stroke="#D8D8D8" stroke-width="0.5"></path>
                      <rect x="92" y="124" width="31" height="4" rx="1" fill="#EEEEEE"></rect>
                      <rect x="92" y="124" width="31" height="4" rx="1" fill="#EEEEEE"></rect>
                      <rect x="92" y="131" width="17" height="4" rx="1" fill="#EEEEEE"></rect>
                      <rect x="130.25" y="89.25" width="36.5" height="49.5" rx="1.75" fill="white"></rect>
                      <rect x="130.25" y="89.25" width="36.5" height="49.5" rx="1.75" stroke="#D8D8D8"
                            stroke-width="0.5"></rect>
                      <path
                        d="M130.25 121.25H166.75V137C166.75 137.966 165.966 138.75 165 138.75H132C131.034 138.75 130.25 137.966 130.25 137V121.25Z"
                        fill="#FAFAFA"></path>
                      <path
                        d="M130.25 121.25H166.75V137C166.75 137.966 165.966 138.75 165 138.75H132C131.034 138.75 130.25 137.966 130.25 137V121.25Z"
                        stroke="#D8D8D8" stroke-width="0.5"></path>
                      <rect x="133" y="124" width="31" height="4" rx="1" fill="#EEEEEE"></rect>
                      <rect x="133" y="131" width="24" height="4" rx="1" fill="#EEEEEE"></rect>
                    </g>
                    <path
                      d="M83.25 47C83.25 42.7198 86.7198 39.25 91 39.25H165C169.28 39.25 172.75 42.7198 172.75 47V135.75H83.25V47Z"
                      stroke="#D8D8D8" stroke-width="0.5"></path>
                    <g filter="url(#filter0_dd_4397_195125)">
                      <rect x="66" y="59" width="124" height="34" rx="4" fill="#FEECE1"></rect>
                      <rect x="66.5" y="59.5" width="123" height="33" rx="3.5" stroke="#EE4D2D"></rect>
                      <rect x="105" y="64" width="75" height="4" rx="1" fill="white"></rect>
                      <rect x="105" y="72" width="32" height="4" rx="1" fill="white"></rect>
                      <rect opacity="0.8" x="105" y="79" width="32" height="8" rx="4" fill="#EE4D2D"
                            fill-opacity="0.2"></rect>
                      <path
                        d="M74.2259 72.2933C74.2259 71.3536 74.9745 70.5918 75.898 70.5918H95.4846C96.4081 70.5918 97.1567 71.3536 97.1567 72.2933V85.2689C97.1567 86.2087 96.4081 86.9705 95.4846 86.9705H75.898C74.9745 86.9705 74.2259 86.2087 74.2259 85.2689V72.2933Z"
                        fill="white"></path>
                      <path
                        d="M76.4366 72.904C76.4366 73.9442 75.608 74.7875 74.5858 74.7875C73.5636 74.7875 72.7349 73.9442 72.7349 72.904C72.7349 71.8638 73.5636 71.0206 74.5858 71.0206C75.608 71.0206 76.4366 71.8638 76.4366 72.904Z"
                        fill="#FFA695"></path>
                      <path
                        d="M80.1384 72.904C80.1384 73.9442 79.3097 74.7875 78.2876 74.7875C77.2654 74.7875 76.4366 73.9442 76.4366 72.904C76.4366 71.8638 77.2654 71.0206 78.2876 71.0206C79.3097 71.0206 80.1384 71.8638 80.1384 72.904Z"
                        fill="#FFA695"></path>
                      <path
                        d="M83.84 72.904C83.84 73.9442 83.0113 74.7875 81.9891 74.7875C80.9669 74.7875 80.1384 73.9442 80.1384 72.904C80.1384 71.8638 80.9669 71.0206 81.9891 71.0206C83.0113 71.0206 83.84 71.8638 83.84 72.904Z"
                        fill="#FFA695"></path>
                      <path
                        d="M87.5417 72.904C87.5417 73.9442 86.7131 74.7875 85.6909 74.7875C84.6687 74.7875 83.84 73.9442 83.84 72.904C83.84 71.8638 84.6687 71.0206 85.6909 71.0206C86.7131 71.0206 87.5417 71.8638 87.5417 72.904Z"
                        fill="#FFA695"></path>
                      <path
                        d="M91.2433 72.904C91.2433 73.9442 90.4147 74.7875 89.3925 74.7875C88.3703 74.7875 87.5417 73.9442 87.5417 72.904C87.5417 71.8638 88.3703 71.0206 89.3925 71.0206C90.4147 71.0206 91.2433 71.8638 91.2433 72.904Z"
                        fill="#FFA695"></path>
                      <path
                        d="M94.9451 72.904C94.9451 73.9442 94.1164 74.7875 93.0943 74.7875C92.0721 74.7875 91.2433 73.9442 91.2433 72.904C91.2433 71.8638 92.0721 71.0206 93.0943 71.0206C94.1164 71.0206 94.9451 71.8638 94.9451 72.904Z"
                        fill="#FFA695"></path>
                      <path
                        d="M98.6467 72.904C98.6467 73.9442 97.818 74.7875 96.7958 74.7875C95.7736 74.7875 94.9451 73.9442 94.9451 72.904C94.9451 71.8638 95.7736 71.0206 96.7958 71.0206C97.818 71.0206 98.6467 71.8638 98.6467 72.904Z"
                        fill="#FFA695"></path>
                      <path
                        d="M74.8612 64.5882C74.973 64.2375 75.2941 64 75.6564 64H95.5086C95.864 64 96.1806 64.2287 96.2978 64.5701L98.9525 72.3015C99.1424 72.8546 98.739 73.4329 98.1633 73.4329H73.1913C72.6235 73.4329 72.2208 72.8692 72.3961 72.3196L74.8612 64.5882Z"
                        fill="#FFBDB0"></path>
                      <path
                        d="M88.3462 78.8702C88.3462 77.9305 89.0948 77.1687 90.0183 77.1687H92.5812C93.5047 77.1687 94.2533 77.9305 94.2533 78.8702V86.9704H88.3462V78.8702Z"
                        fill="#E7E4E4"></path>
                      <path
                        d="M76.8112 78.8702C76.8112 77.9305 77.5598 77.1687 78.4832 77.1687H85.4958C86.4193 77.1687 87.1679 77.9305 87.1679 78.8702V82.9803C87.1679 83.92 86.4193 84.6819 85.4958 84.6819H78.4832C77.5598 84.6819 76.8112 83.92 76.8112 82.9803V78.8702Z"
                        fill="#F0F0F0"></path>
                      <path
                        d="M79.2289 85.2643C79.6444 87.2119 78.0637 86.9692 77.0174 86.9692C75.9712 86.9692 73.8846 87.1075 73.8846 86.0428C73.8846 84.9781 75.2193 83.1117 76.7358 83.1117C77.782 83.1117 78.9409 83.9145 79.2289 85.2643Z"
                        fill="#FFC7BC"></path>
                      <path
                        d="M77.1765 85.4562C77.2526 87.1749 76.1094 86.9744 74.0022 86.9744C71.5981 86.9744 70 87.2904 70 85.7028C70 84.2183 71.3319 83.515 72.1499 83.7668C73.0251 81.2497 77.0369 82.3051 77.1765 85.4562Z"
                        fill="#FFDAD2"></path>
                      <path d="M83.609 83.6075H82.5973L85.2196 80.4853H86.2529L83.609 83.6075Z" fill="white"></path>
                      <path d="M85.268 83.631H84.2563L85.8075 81.8537L86.6991 81.8538L85.268 83.631Z"
                            fill="white"></path>
                      <path
                        d="M89.1072 78.9267C89.1072 78.4568 89.4815 78.0759 89.9432 78.0759H92.6559C93.1176 78.0759 93.4919 78.4568 93.4919 78.9267V81.2115H89.1072V78.9267Z"
                        fill="white"></path>
                    </g>
                    <defs>
                      <filter id="filter0_dd_4397_195125" x="50" y="43" width="156" height="74"
                              filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                        <feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood>
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                       result="hardAlpha"></feColorMatrix>
                        <feOffset dy="8"></feOffset>
                        <feGaussianBlur stdDeviation="8"></feGaussianBlur>
                        <feColorMatrix type="matrix"
                                       values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"></feColorMatrix>
                        <feBlend mode="normal" in2="BackgroundImageFix"
                                 result="effect1_dropShadow_4397_195125"></feBlend>
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                       result="hardAlpha"></feColorMatrix>
                        <feOffset></feOffset>
                        <feGaussianBlur stdDeviation="8"></feGaussianBlur>
                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"></feColorMatrix>
                        <feBlend mode="normal" in2="effect1_dropShadow_4397_195125"
                                 result="effect2_dropShadow_4397_195125"></feBlend>
                        <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_4397_195125"
                                 result="shape"></feBlend>
                      </filter>
                      <clipPath id="clip0_4397_195125">
                        <path d="M83 47C83 42.5817 86.5817 39 91 39H165C169.418 39 173 42.5817 173 47V136H83V47Z"
                              fill="white"></path>
                      </clipPath>
                    </defs>
                  </svg>
                </div>

                <div class="mt-[30px] text-center">
                  <strong class="text-[18px]">{{ $t('ads.shop_ads') }}</strong>
                </div>
                <div class="mt-[10px] h-[60px] text-center">
                  <span class="text-[13px] text-[#666]">
                    Hiển thị Shop của bạn ở vị trí đầu Trang kết quả tìm kiếm.
                  </span>
                </div>
              </el-card>
              <div v-if="ads_data && ads_data.ads_toggle && !ads_data.ads_toggle.enable_shop_ads_v2"
                   style="position: absolute; top: 0; left: 0; background: #fef9c3; margin: 10px 12px; padding: 4px ; text-align: center">
                Hiện tại bạn không đủ điều kiện để sử dụng Quảng cáo Shop.
              </div>
            </div>
          </div>
          <div class="flex-1">
            <div :class="add_campaign_type === 'live_stream' ? 'card-fixed-active' : 'card-fixed'"
                 @click="add_campaign_type = 'live_stream'">
              <el-card :shadow="add_campaign_type === 'live_stream' ? 'always' : 'never'">
                <div>
                  <svg viewBox="0 0 256 160" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect width="256" height="160" rx="4" fill="white"></rect>
                    <g clip-path="url(#clip0_4415_197359)">
                      <path d="M83 47C83 42.5817 86.5817 39 91 39H165C169.418 39 173 42.5817 173 47V136H83V47Z"
                            fill="#FAFAFA"></path>
                      <path
                        d="M93.6582 55.1255V56H90.4458V55.1255H93.6582ZM90.7534 49.6016V56H89.6504V49.6016H90.7534ZM95.5391 51.2451V56H94.4756V51.2451H95.5391ZM94.4053 49.9971C94.4053 49.8359 94.458 49.7026 94.5635 49.5972C94.6719 49.4888 94.8213 49.4346 95.0117 49.4346C95.1992 49.4346 95.3472 49.4888 95.4556 49.5972C95.564 49.7026 95.6182 49.8359 95.6182 49.9971C95.6182 50.1553 95.564 50.2871 95.4556 50.3926C95.3472 50.498 95.1992 50.5508 95.0117 50.5508C94.8213 50.5508 94.6719 50.498 94.5635 50.3926C94.458 50.2871 94.4053 50.1553 94.4053 49.9971ZM98.2461 55.1606L99.4106 51.2451H100.509L98.8569 56H98.1714L98.2461 55.1606ZM97.354 51.2451L98.5405 55.1782L98.5977 56H97.9121L96.251 51.2451H97.354ZM103.199 56.0879C102.847 56.0879 102.529 56.0308 102.245 55.9165C101.964 55.7993 101.724 55.6367 101.524 55.4287C101.328 55.2207 101.177 54.9761 101.072 54.6948C100.966 54.4136 100.914 54.1104 100.914 53.7852V53.6094C100.914 53.2373 100.968 52.9004 101.076 52.5986C101.185 52.2969 101.335 52.0391 101.529 51.8252C101.722 51.6084 101.951 51.4429 102.214 51.3286C102.478 51.2144 102.764 51.1572 103.071 51.1572C103.411 51.1572 103.708 51.2144 103.963 51.3286C104.218 51.4429 104.429 51.604 104.596 51.812C104.766 52.0171 104.892 52.2617 104.974 52.5459C105.059 52.8301 105.102 53.1436 105.102 53.4863V53.939H101.428V53.1787H104.056V53.0952C104.05 52.9048 104.012 52.7261 103.941 52.5591C103.874 52.3921 103.77 52.2573 103.629 52.1548C103.489 52.0522 103.301 52.001 103.067 52.001C102.891 52.001 102.734 52.0391 102.597 52.1152C102.462 52.1885 102.349 52.2954 102.258 52.436C102.167 52.5767 102.097 52.7466 102.047 52.9458C102 53.1421 101.977 53.3633 101.977 53.6094V53.7852C101.977 53.9932 102.005 54.1865 102.061 54.3652C102.119 54.541 102.204 54.6948 102.315 54.8267C102.427 54.9585 102.562 55.0625 102.72 55.1387C102.878 55.2119 103.058 55.2485 103.26 55.2485C103.515 55.2485 103.742 55.1973 103.941 55.0947C104.141 54.9922 104.313 54.8472 104.46 54.6597L105.018 55.2002C104.916 55.3496 104.782 55.4932 104.618 55.6309C104.454 55.7656 104.253 55.8755 104.016 55.9604C103.782 56.0454 103.509 56.0879 103.199 56.0879Z"
                        fill="#D8D8D8"></path>
                      <rect x="89.25" y="63.25" width="36.5" height="49.5" rx="1.75" fill="white"></rect>
                      <rect x="89.25" y="63.25" width="36.5" height="49.5" rx="1.75" stroke="#D8D8D8"
                            stroke-width="0.5"></rect>
                      <rect x="92" y="106" width="31" height="4" rx="1" fill="#EEEEEE"></rect>
                      <rect x="130.25" y="63.25" width="36.5" height="49.5" rx="1.75" fill="white"></rect>
                      <rect x="130.25" y="63.25" width="36.5" height="49.5" rx="1.75" stroke="#D8D8D8"
                            stroke-width="0.5"></rect>
                      <rect x="133" y="106" width="31" height="4" rx="1" fill="#EEEEEE"></rect>
                      <rect x="89.25" y="117.25" width="36.5" height="49.5" rx="1.75" fill="white"></rect>
                      <rect x="89.25" y="117.25" width="36.5" height="49.5" rx="1.75" stroke="#D8D8D8"
                            stroke-width="0.5"></rect>
                      <rect x="130.25" y="117.25" width="36.5" height="49.5" rx="1.75" fill="white"></rect>
                      <rect x="130.25" y="117.25" width="36.5" height="49.5" rx="1.75" stroke="#D8D8D8"
                            stroke-width="0.5"></rect>
                    </g>
                    <path
                      d="M83.25 47C83.25 42.7198 86.7198 39.25 91 39.25H165C169.28 39.25 172.75 42.7198 172.75 47V135.75H83.25V47Z"
                      stroke="#D8D8D8" stroke-width="0.5"></path>
                    <g filter="url(#filter0_dd_4415_197359)">
                      <rect x="69" y="59" width="59" height="81" rx="4" fill="#FEECE1"></rect>
                      <rect x="69.5" y="59.5" width="58" height="80" rx="3.5" stroke="#EE4D2D"></rect>
                      <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M88.868 89.888V92.0594C88.868 92.0594 85.0403 91.6436 85.0403 94.5545C85.0404 97.4653 88.868 97.2574 88.868 97.2574C88.868 97.2574 88.868 105.128 94.6094 107.69V109.664C94.6094 110.564 94.0078 111.353 93.1397 111.592L87.8163 113.056C83.7901 114.163 81 117.824 81 122H116.725C116.725 117.819 113.944 114.148 109.92 113.015L109.707 112.955L104.148 111.39C103.286 111.148 102.69 110.361 102.69 109.465V107.697C108.495 105.142 108.644 97.2574 108.644 97.2574C108.644 97.2574 112.472 97.0495 112.472 94.5545C112.472 92.0594 108.644 92.0594 108.644 92.0594V89.888C108.644 84.427 104.217 80 98.756 80C93.295 80 88.868 84.427 88.868 89.888Z"
                            fill="white"></path>
                      <rect opacity="0.8" x="73" y="125" width="10" height="10" rx="5" fill="#EE4D2D"
                            fill-opacity="0.2"></rect>
                      <rect opacity="0.8" x="87" y="128" width="40" height="5" rx="2.5" fill="#EE4D2D"
                            fill-opacity="0.2"></rect>
                      <path
                        d="M73 66C73 64.8954 73.8954 64 75 64H93C94.1046 64 95 64.8954 95 66V70C95 71.1046 94.1046 72 93 72H75C73.8954 72 73 71.1046 73 70V66Z"
                        fill="#F59680"></path>
                      <path
                        d="M83.9395 69.3408V70H82.1426V69.3408H83.9395ZM82.4478 66.4453V70H81.5908V66.4453H82.4478ZM85.1309 67.3584V70H84.3057V67.3584H85.1309ZM84.2568 66.6772C84.2568 66.5601 84.2992 66.464 84.3838 66.3892C84.4684 66.3143 84.5783 66.2769 84.7134 66.2769C84.8485 66.2769 84.9583 66.3143 85.043 66.3892C85.1276 66.464 85.1699 66.5601 85.1699 66.6772C85.1699 66.7944 85.1276 66.8905 85.043 66.9653C84.9583 67.0402 84.8485 67.0776 84.7134 67.0776C84.5783 67.0776 84.4684 67.0402 84.3838 66.9653C84.2992 66.8905 84.2568 66.7944 84.2568 66.6772ZM86.5908 69.436L87.1108 67.3584H87.9775L87.1133 70H86.6006L86.5908 69.436ZM86.2832 67.3584L86.7959 69.436L86.791 70H86.2759L85.4141 67.3584H86.2832ZM89.4668 70.0488C89.252 70.0488 89.0599 70.0155 88.8906 69.9487C88.7214 69.8804 88.5781 69.7868 88.4609 69.668C88.3454 69.5492 88.2567 69.4124 88.1948 69.2578C88.1346 69.1032 88.1045 68.9396 88.1045 68.7671V68.6743C88.1045 68.4806 88.1313 68.3016 88.1851 68.1372C88.2388 67.9712 88.3185 67.8263 88.4243 67.7026C88.5301 67.5789 88.6628 67.4829 88.8223 67.4146C88.9818 67.3446 89.1673 67.3096 89.3789 67.3096C89.5661 67.3096 89.7337 67.3397 89.8818 67.3999C90.0299 67.4601 90.1553 67.5464 90.2578 67.6587C90.362 67.771 90.4409 67.9069 90.4946 68.0664C90.55 68.2259 90.5776 68.4049 90.5776 68.6035V68.938H88.4194V68.4229H89.7744V68.3594C89.776 68.2715 89.7606 68.1966 89.728 68.1348C89.6971 68.0729 89.6515 68.0257 89.5913 67.9932C89.5311 67.9606 89.4578 67.9443 89.3716 67.9443C89.2821 67.9443 89.208 67.9639 89.1494 68.0029C89.0924 68.042 89.0477 68.0957 89.0151 68.1641C88.9842 68.2308 88.9622 68.3081 88.9492 68.396C88.9362 68.4839 88.9297 68.5767 88.9297 68.6743V68.7671C88.9297 68.8647 88.9427 68.9535 88.9688 69.0332C88.9964 69.113 89.0355 69.1813 89.0859 69.2383C89.138 69.2936 89.1999 69.3368 89.2715 69.3677C89.3447 69.3986 89.4277 69.4141 89.5205 69.4141C89.6328 69.4141 89.7435 69.3929 89.8525 69.3506C89.9616 69.3083 90.0552 69.2383 90.1333 69.1406L90.5068 69.585C90.4531 69.6615 90.3766 69.7355 90.2773 69.8071C90.1797 69.8787 90.0625 69.9373 89.9258 69.9829C89.7891 70.0269 89.6361 70.0488 89.4668 70.0488Z"
                        fill="white"></path>
                      <path opacity="0.8"
                            d="M109 68C109 65.7909 110.791 64 113 64H127V72H113C110.791 72 109 70.2091 109 68Z"
                            fill="#FBD3C4"></path>
                      <rect x="75" y="66" width="4" height="4" rx="2" fill="white"></rect>
                    </g>
                    <defs>
                      <filter id="filter0_dd_4415_197359" x="53" y="43" width="91" height="121"
                              filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                        <feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood>
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                       result="hardAlpha"></feColorMatrix>
                        <feOffset dy="8"></feOffset>
                        <feGaussianBlur stdDeviation="8"></feGaussianBlur>
                        <feColorMatrix type="matrix"
                                       values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"></feColorMatrix>
                        <feBlend mode="normal" in2="BackgroundImageFix"
                                 result="effect1_dropShadow_4415_197359"></feBlend>
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                       result="hardAlpha"></feColorMatrix>
                        <feOffset></feOffset>
                        <feGaussianBlur stdDeviation="8"></feGaussianBlur>
                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"></feColorMatrix>
                        <feBlend mode="normal" in2="effect1_dropShadow_4415_197359"
                                 result="effect2_dropShadow_4415_197359"></feBlend>
                        <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_4415_197359"
                                 result="shape"></feBlend>
                      </filter>
                      <clipPath id="clip0_4415_197359">
                        <path d="M83 47C83 42.5817 86.5817 39 91 39H165C169.418 39 173 42.5817 173 47V136H83V47Z"
                              fill="white"></path>
                      </clipPath>
                    </defs>
                  </svg>
                </div>

                <div class="mt-[30px] text-center">
                  <strong class="text-[18px]">{{ 'Tăng hiển thị cho Livestream' }}</strong>
                </div>
                <div class="mt-[10px] h-[60px] text-center">
                  <span class="text-[13px] text-[#666]">
                    Quảng bá Livestream tới người mua tiềm năng
                  </span>
                </div>
              </el-card>
            </div>
          </div>
        </div>

        <div style="margin-top: 40px" class="text-right">
          <el-button size="small" type="primary" icon="el-icon-check" @click="m__redirect_add_campaign">
            {{ $t('base.confirm') }}
          </el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="show_dialog.surge_setting" :close-on-click-modal="false"
               custom-class="no-body"
               width="800px">
      <div slot="title" style="padding:20px">
        <div>
          <strong style="font-size: 16px">{{ $t('ads.surge.title') }}</strong>
        </div>
        <div style="margin-top: 10px">
          <span style="font-size: 13px; color: #888">
            {{ $t('ads.surge.note') }}
          </span>
        </div>
        <div style="margin-top: 20px">
          <el-table :data="setting_list" style="border-radius: 5px; border: 1px solid #EBEEF5">
            <el-table-column :label="$t('base.settings')">
              <template slot-scope="scope">
                <div style="display: flex; align-items: center; gap: 12px">
                  {{ scope.row.label }}
                  <el-tooltip class="item" effect="dark" :content="scope.row.tool_tip" placement="top">
                    <i class="el-icon-question" style="font-size: 18px !important;"></i>
                  </el-tooltip>
                </div>
              </template>
            </el-table-column>
            <el-table-column :label="$t('base.status')" width="160px">
              <template slot-scope="scope">
                <template v-if="scope.row.type === 'surge'">
                  <strong v-if="surge_setting_status" class="text-success">{{ $t('base.on') }}</strong>
                  <strong v-else class="text-grey">{{ $t('base.off') }}</strong>
                </template>
                <template v-if="scope.row.type === 'auto_budget_increase'">
                  <strong v-if="auto_budget_increase_status" class="text-success">{{ $t('base.on') }}</strong>
                  <strong v-else class="text-grey">{{ $t('base.off') }}</strong>
                </template>
                <template v-if="scope.row.type === 'erp_platform'">
                  <strong v-if="shop && shop.extra_data && shop.extra_data.linked" class="text-success">
                    {{ $t('base.connected') }}
                  </strong>
                  <strong v-else class="text-danger">
                    {{ $t('base.not_connected') }}
                  </strong>
                </template>
                <template v-if="scope.row.type === 'ads_platform'">
                  <strong v-if="is_connected_ads_platform" class="text-success">
                    {{ $t('base.connected') }}
                  </strong>
                  <strong v-else class="text-danger">
                    {{ $t('base.not_connected') }}
                  </strong>
                </template>
                <template v-if="scope.row.type === 'ads_platform'">
                </template>
              </template>
            </el-table-column>
            <el-table-column :label="$t('base.action')" width="200px">
              <template slot-scope="scope">
                <template v-if="scope.row.type === 'surge'">
                  <el-button v-if="surge_setting_status" type="text" size="mini"
                             @click="surge_setting_status = false; m__set_set_smart_booster()">
                    <strong class="text-primary">{{ $t('base.turn_off') }}</strong>
                  </el-button>
                  <el-button v-else type="text" size="mini"
                             @click="surge_setting_status = true; m__set_set_smart_booster()">
                    <strong class="text-primary">{{ $t('base.turn_on') }}</strong>
                  </el-button>
                </template>
                <template v-if="scope.row.type === 'auto_budget_increase'">
                  <el-button v-if="auto_budget_increase_status" type="text" size="mini"
                             @click="auto_budget_increase_status = false; m__set_set_smart_booster()">
                    <strong class="text-primary">{{ $t('base.turn_off') }}</strong>
                  </el-button>
                  <el-button v-else type="text" size="mini"
                             @click="auto_budget_increase_status = true; m__set_set_smart_booster()">
                    <strong class="text-primary">{{ $t('base.turn_on') }}</strong>
                  </el-button>
                </template>
                <template v-if="scope.row.type === 'erp_platform'">
                  <el-button type="text" size="mini" @click="m__get_connect_erp_platform_login_url()">
                    <strong v-if="shop && shop.extra_data && shop.extra_data.linked" class="text-primary">
                      {{ $t('base.reconnect') }}
                    </strong>
                    <strong v-else class="text-primary">
                      {{ $t('base.connect') }}
                    </strong>
                  </el-button>
                </template>
                <template v-if="scope.row.type === 'ads_platform'">
                  <el-button type="text" size="mini" @click="m__get_connect_ads_platform_login_url()">
                    <strong v-if="is_connected_ads_platform" class="text-primary">
                      {{ $t('base.reconnect') }}
                    </strong>
                    <strong v-else class="text-primary">
                      {{ $t('base.connect') }}
                    </strong>
                  </el-button>
                </template>
                <template v-if="scope.row.type === 'cancelled_declaration'">
                  <div style="display: flex; flex-direction: column;">
                    <el-checkbox-group v-model="cancelled_declaration">
                      <el-checkbox label="CANCELLED" size="mini">Đơn đã hủy</el-checkbox>
                      <el-checkbox label="TO_RETURN" size="mini">Đơn hàng hoàn</el-checkbox>
                      <el-checkbox label="FAILED_DELIVERED" size="mini">Giao hàng thất bại</el-checkbox>
                    </el-checkbox-group>

                    <div style="margin: 10px 0">
                      <el-select v-model="cancelled_type" value="" size="mini">
                        <el-option :value="'placed'" :label="$t('center.placed_order')"></el-option>
                        <el-option :value="'confirmed'" :label="$t('center.confirmed_order')"></el-option>
                        <el-option :value="'paid'" :label="$t('center.paid_order')"></el-option>
                      </el-select>
                    </div>
                  </div>
                </template>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div style="margin-top: 30px; text-align: right">
          <el-button size="mini" icon="el-icon-close">{{ $t('base.close') }}</el-button>
          <el-button type="primary" size="mini" icon="el-icon-check" @click="update_shop_config()">
            {{ $t('base.confirm') }}
          </el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="show_dialog.collect_fees" :close-on-click-modal="false"
               custom-class="no-body"
               width="800px">
      <div slot="title" style="padding:20px">
        <div>
          <strong style="font-size: 18px">{{ $t('ads.fee_collection_notice').toUpperCase() }}</strong>
        </div>

        <div style="margin-top: 30px; font-size: 14px !important; line-height: 20px;">
          {{ $t('ads.dear_customer') }},
          <br>
          <br>
          {{ $t('ads.first_line') }}.
          <br>
          <br>
          {{ $t('ads.second_line') }}:
          <br>
          <br>
          1. Tính năng tối ưu theo điều kiện:
          <br>
          <ul style="margin-top: 10px; margin-left: 0">
            <li style="padding-left: 1px; font-size: 14px; margin-bottom: 5px">
              Cách tính phí: Phí sẽ được tính dựa trên Trung bình CIR (ACOS) của 3 tháng trước, và sẽ chỉ thu phí khi
              CIR ngày nhỏ hơn mức CIR trung bình.
            </li>
            <li style="padding-left: 1px; font-size: 14px; margin-bottom: 5px">
              Đối với doanh thu từ 0 - 10 triệu: Miễn phí
            </li>
            <li style="padding-left: 1px; font-size: 14px; margin-bottom: 5px">
              Đối với doanh thu từ 10 - 50 triệu: Phí 2% doanh thu
            </li>
            <li style="padding-left: 1px; font-size: 14px; margin-bottom: 5px">
              Đối với doanh thu từ 50 - 100 triệu: Phí 1.5% doanh thu
            </li>
            <li style="padding-left: 1px; font-size: 14px; margin-bottom: 5px">
              Đối với doanh thu từ 100 - 300 triệu : Phí 1.3% doanh thu
            </li>
            <li style="padding-left: 1px; font-size: 14px; margin-bottom: 5px">
              Đối với doanh thu từ 300 triệu trở lên: Phí 1% doanh thu
            </li>
          </ul>
          <br>
          {{ $t('ads.fourth_line') }}
          <br>
          {{ $t('ads.fifth_line') }}
        </div>

        <div style="margin-top: 40px; display: flex; justify-items: center">
          <div style="flex: 1">
            <el-checkbox>{{ $t('ads.do_not_show_again') }}</el-checkbox>
          </div>
          <div style="flex: 1; text-align: right">
            <el-button type="primary" size="mini" icon="el-icon-check" @click="show_dialog.collect_fees = false">
              {{ $t('ads.read_and_confirm') }}
            </el-button>
          </div>
        </div>
      </div>
    </el-dialog>

    <el-drawer
      v-if="false"
      :visible.sync="show_dialog.chatbot"
      :with-header="false"
      :title="''"
      :size="'60%'"
      :show-close="true">
      <div>
        <ComponentChatbot :shop="shop"></ComponentChatbot>
      </div>
    </el-drawer>

    <el-dialog :visible.sync="show_dialog.atosa_agent_unpaid" :close-on-click-modal="false"
               custom-class="no-body" width="600px" class="ongoing-bg">
      <div slot="title" class="p-[20px]">
        <div class="text-[20px] text-center text-bold pt-[10px]">
          Thông báo: Thanh toán phí vận hành Atosa Agent AI
        </div>

        <div v-if="atosa_agent_unpaid" class="text-[14px] mt-[50px] font-semibold">
          💥 Bạn đang có {{ atosa_agent_unpaid.total }} giao dịch chưa được thanh toán trên Atosa Agent AI từ
          ngày {{ timeFormat(atosa_agent_unpaid.last_document_time, 'DD/MM/YYYY') }} với tổng chi phí vận hành là
          {{ m__calculate(atosa_agent_unpaid.total_unpaid_cost) | currency }}.
          Các cấu hình hiện đang tạm dừng, vui lòng thanh toán để tiếp tục sử dụng tính năng.
        </div>

        <div v-if="atosa_agent_unpaid" class="mt-[30px] text-center">
          <button class="payment-button"
                  @click="m__confirm_charge_unpaid_operating_cost(); show_dialog.atosa_agent_unpaid = false">
            Thanh toán chi phí ngay
          </button>
        </div>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="show_dialog.connected_ads_platform_required" :close-on-click-modal="false"
               custom-class="no-body" width="680px" class="ongoing-bg">
      <div slot="title" class="p-[20px]">
        <div style="line-height: 30px; color: #222;">
          <p style="font-size: 20px; margin-bottom: 12px;">📢 Thông Báo Kết Nối Hệ Thống Atosa Ads Platform</p>

          <p style="font-size: 14px">Kính gửi Quý khách,</p>

          <p style="font-size: 14px">
            Để đảm bảo hệ thống vận hành ổn định và giúp tối ưu hiệu quả quảng cáo,
            vui lòng tiến hành <strong style="font-size: 14px">kết nối tài khoản của Quý khách với nền tảng Atosa Ads
            Platform</strong>.
          </p>

          <p style="font-size: 14px">Việc kết nối này sẽ giúp:</p>
          <ul style="font-size: 14px">
            <li style="font-size: 14px">Đồng bộ dữ liệu quảng cáo nhanh chóng và chính xác</li>
            <li style="font-size: 14px">Tối ưu ngân sách và hiệu suất chiến dịch tự động</li>
            <li style="font-size: 14px">Theo dõi, báo cáo và phân tích hiệu quả chi tiết hơn</li>
          </ul>

          <p style="font-size: 14px">
            Nếu cần hỗ trợ, Quý khách có thể liên hệ đội ngũ kỹ thuật của chúng tôi bất cứ lúc nào.
          </p>

          <p style="font-size: 14px">Trân trọng,<br>
            <strong style="font-size: 14px">Đội ngũ Atosa Ads Platform</strong></p>
        </div>

        <div class="mt-[30px] text-center">
          <button class="payment-button"
                  @click="m__get_connect_ads_platform_login_url(); show_dialog.connected_ads_platform_required = false">
            Kết nối Nền tảng Atosa Ads Platform
          </button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {picker_options} from '../../addon/options'
import PasCampaignComponent from './campaign'
import CreateProductComponent from './component/create_product.vue'
import CreateShopComponent from './component/create_shop.vue'
import CreateLiveStreamComponent from './component/create_live_stream.vue'
import {make_uuid} from '../../addon/ads_function'
import {check_channel, show_expr_notification} from '../../addon/check_license'
import {get_shop_mixins} from '../../mixins/get_shop'
import {fix_ads_mixins} from '../../mixins/fix_ads'
import {atosa_ai_fixed_list} from '../../addon/fixed_list'
import {package_mixins} from '../../mixins/package'
import {FFF_COM_VN} from '../../addon/fff'
import {global_shops} from '../../addon/global_config'
import {orderBy as _orderBy} from 'lodash'
import ComponentChatbot from './component/component_chatbot.vue'

export default {
  mixins: [get_shop_mixins, fix_ads_mixins, package_mixins],

  components: {
    PasCampaignComponent,
    CreateProductComponent,
    CreateShopComponent,
    CreateLiveStreamComponent,
    ComponentChatbot,
  },

  data() {
    return {
      picker_options,
      balance: 0,
      current_tab: 'new_cpc_homepage_group',
      current_component: 'list',
      campaign_component: 'list',
      component_key: '',
      sp_user: null,
      date_range: [new Date(), new Date()],
      start_date: null,
      end_date: null,
      loading: {
        get_products: false,
        add_campaign_type: false,
      },
      show_dialog: {
        select_hour: false,
        add_campaign_type: false,
        setup_flow_old_version: false,
        surge_setting: false,
        collect_fees: false,
        chatbot: false,
        atosa_agent_unpaid: false,
        connected_ads_platform_required: false
      },
      hour_mode: false,
      add_campaign_type: 'product',
      product_list: [],

      agency_files: [],
      agency_file_selected: null,
      agency_file_id_selected: null,
      ads_config: {},
      ads_data: {},
      non_ads_data: {},

      getting_campaigns: false,

      is_compare_campaign: false,
      compare_date_range: [new Date().getTime() - 3600 * 1000 * 24 * 6, new Date().getTime() - 3600 * 1000 * 24],

      selected_product_ids: [],

      smart_booster: {},

      surge_setting_status: false,
      auto_budget_increase_status: false,
      smart_voucher_status: false,

      setting_list: [
        {
          type: 'surge',
          label: this.$t('ads.surge.setting'),
          tool_tip: this.$t('ads.surge_tool_tip'),
        },
        {
          type: 'auto_budget_increase',
          label: 'Tự động Tăng Ngân sách (Không khuyến nghị bật)',
          tool_tip: 'Tự động Tăng ngân sách hàng ngày cho Chiến dịch đang có hiệu quả cao. để tránh hết ngân sách Dịch vụ Hiển thị dẫn tới Dịch vụ Hiển thị bị gián đoạn và tối đa hóa khả năng hiển thị cho các chiến dịch đang có hiệu quả cao.',
        },
        {
          type: 'erp_platform',
          label: this.$t('ads.connect_erp_platform'),
          tool_tip: this.$t('ads.connect_erp_platform_tool_tip'),
        },
        {
          type: 'ads_platform',
          label: this.$t('ads.connect_ads_platform'),
          tool_tip: this.$t('ads.connect_ads_platform_tool_tip'),
        },
        {
          type: 'cancelled_declaration',
          label: 'Định nghĩa đơn hoàn hủy',
          tool_tip: 'Định nghĩa trạng thái của các đơn hoàn hủy để tính toán chỉ số GMV + ROI trừ hoàn hủy',
        },
      ],

      is_connected_ads_platform: true,

      cascader_options: [
        {
          value: 'all',
          label: this.$t('base.all_categories'),
        },
        {
          value: 'shopee',
          label: this.$t('base.shopee_category'),
          children: [],
        },
        {
          value: 'my_shop',
          label: this.$t('base.my_shop_category'),
          children: [],
        },
      ],

      fff: null,
      active_campaign_list: [],

      filter_clone: null,

      min_atosa_balance: 100000,

      welcome_atosa_agent_showed_dialog: false,
      unpaid_atosa_agent_showed_dialog: false,

      atosa_agent_package: null,
      atosa_agent_unpaid: null,
      atosa_agent_unpaid_max_hour: 12,

      atosa_ai_fixed_list: atosa_ai_fixed_list,
      allow_show_alert: false,

      cancelled_type: '',
      default_cancelled_type: 'confirmed',
      cancelled_declaration: [],
      default_cancelled_declaration: ['CANCELLED', 'TO_RETURN', 'FAILED_DELIVERED']
    }
  },

  beforeRouteEnter(to, from, next) {
    if (check_channel('shopee_marketing')) {
      next()
    } else {
      show_expr_notification()
      next('/')
    }
  },

  async beforeMount() {
    if (this.$route.query.type) this.current_tab = this.$route.query.type || 'product_homepage'

    if (+this.$route.query.from) this.date_range[0] = new Date(+this.$route.query.from)
    if (+this.$route.query.to) this.date_range[1] = new Date(+this.$route.query.to)

    if (this.$route.query.is_compare) this.is_compare_campaign = true
    if (+this.$route.query.compare_from) this.compare_date_range[0] = new Date(+this.$route.query.compare_from)
    if (+this.$route.query.compare_to) this.compare_date_range[1] = new Date(+this.$route.query.compare_to)

    this.component_key = make_uuid()

    if (this.date_range) {
      this.start_date = this.date_range[0]
      this.end_date = this.date_range[1]
    }

    this.fff = new FFF_COM_VN()
    if (this.shop.extra_data && this.shop.extra_data.is_global && this.shop.extra_data.country) {
      const global_found = global_shops.find(i => i.country === this.shop.extra_data.country)
      if (global_found && global_found.fff_config) {
        this.fff.lang = global_found.fff_config.lang
        this.fff.country = global_found.fff_config.country
      }
    }

    await this.m__get_shopee_shop()
    await this.m__get_agency_file()
    await this.m__get_cancelled_declaration()

    // window.addEventListener('message', (event) => {
    //   if (event.origin !== window.location.origin) {
    //     console.error('message from invalid origin:', event.origin);
    //     return;
    //   }
    //
    //   const message_data = event.data;
    //   if (message_data.source === 'connect_ads_platform') {
    //     console.log('message data:', message_data);
    //   }
    // });
  },

  watch: {
    'current_tab': async function () {
      this.component_key = make_uuid()
      await this.m__initial_view(false)
    },

    'shopee_shop.selected': function () {
      this.welcome_atosa_agent_showed_dialog = false
      this.unpaid_atosa_agent_showed_dialog = false
      this.allow_show_alert = false
      this.m__initial_view()
    },
  },

  computed: {
    c__has_advanced_ads() {
      return this.$store.state.advanced_ads_list.some(i => this.$store.state.userInfo.username.includes(i))
    },
  },

  methods: {
    async update_shop_config() {
      await this.m__update_cancelled_declaration()
      this.show_dialog.surge_setting = false
    },

    async m__get_cancelled_declaration() {
      const response = await this.$http.get(this.API.URL_API_SRV_2 + '/shopee/get_cancelled_declaration', this.cf())
      this.cancelled_type = response.body.type ? response.body.type : this.default_cancelled_type
      this.cancelled_declaration = response.body.data.length ? response.body.data : this.default_cancelled_declaration
    },

    async m__update_cancelled_declaration() {
      await this.$http.post(this.API.URL_API_SRV_2 + '/shopee/update_cancelled_declaration', {
        cancelled_type: this.cancelled_type,
        cancelled_declaration: this.cancelled_declaration
      }, this.cf())
    },

    async m__redirect_to_buy_atosa_agent() {
      try {
        await this.$confirm(
          `Gói sản phẩm sẽ chỉ kích hoạt riêng cho từng shop, bạn có chắc chắn muốn mua gói cho shop "${this.shop.username}" không?`,
          this.$t('base.attention'), {
            type: 'warning',
            confirmButtonText: this.$t('base.confirm'),
            cancelButtonText: this.$t('base.cancel'),
          })
      } catch (e) {
        return
      }

      this.open_link(`https://banhang.atosa.asia/authenticate/handle?redirect=${encodeURIComponent(
        `/payment/transfer?channel=atosa_agent&extra=${JSON.stringify(
          {shop_id: this.shop._id})}`)}&token=${this.$store.state.userInfo.token}`)
    },

    m__has_agent() {
      return this.array_to_set(atosa_ai_fixed_list).has(this.$store.state.userInfo.username) ||
        !!this.atosa_agent_package
    },

    async m__confirm_charge_unpaid_operating_cost() {
      if (!this.atosa_agent_unpaid || !this.atosa_agent_unpaid.total_unpaid_cost) return

      if (this.$store.state.userInfo.store_current_money >= this.atosa_agent_unpaid.total_unpaid_cost) {
        try {
          await this.$confirm(`Bạn có chắc chắn muốn thực hiện thanh toán số tiền: ${this.format_currency(
            this.m__calculate(this.atosa_agent_unpaid.total_unpaid_cost))} không?`, this.$t('base.attention'), {
            type: 'warning',
            confirmButtonText: this.$t('base.confirm'),
            cancelButtonText: this.$t('base.cancel'),
          })
        } catch (e) {
          return
        }

        await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/atosa_agent/charge_unpaid_cost', {
          shop_id: this.shop._id,
        }, this.cf())
        await this.m__get_unpaid_operating_cost()

        this.ntf_s('Thanh toán thành công')
      } else {
        try {
          await this.$confirm(`Số dư tài khoản của bạn không đủ để thực hiện thanh toán số tiền: ${this.format_currency(
              this.m__calculate(this.atosa_agent_unpaid.total_unpaid_cost))}! Bạn có muốn nạp thêm tiền không?`,
            this.$t('base.attention'), {
              type: 'warning',
              confirmButtonText: 'Nạp tiền ngay',
              cancelButtonText: this.$t('base.cancel'),
            })
        } catch (e) {
          return
        }

        this.open_link('https://banhang.atosa.asia/payment/transfer')
      }
    },

    m__check_atosa_agent_used_package() {
      const agent_found = this.atosa_agent_package
      if (agent_found) {
        return this.dayjs().isBefore(new Date(agent_found.expired_at), 'second') /*&& !this.m__check_is_unpaid_operating_cost()*/
          ? {
            result: true,
            package_name: agent_found.package_name,
            license_to: this.dayjs(new Date(agent_found.expired_at)).format('HH:mm DD/MM/YYYY'),
            about_to_expired: this.dayjs(new Date(agent_found.expired_at)).diff(this.dayjs(), 'day') <= 5,
            expired_at: this.dayjs(new Date(agent_found.expired_at)).format('DD/MM/YYYY'),
          }
          : {
            result: false,
            about_to_expired: false,
          }
      }
      return {
        result: false,
        about_to_expired: false,
      }
    },

    async m__get_current_atosa_agent_package() {
      this.atosa_agent_package = null
      const response = await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/atosa_agent/current_package',
        {shop_id: this.shop._id}, this.cf())
      this.atosa_agent_package = response.body.data
    },

    m__check_is_unpaid_operating_cost() {
      return this.atosa_agent_unpaid && this.atosa_agent_unpaid.last_diff_hour &&
        this.atosa_agent_unpaid.last_diff_hour > this.atosa_agent_unpaid_max_hour
    },

    async m__get_unpaid_operating_cost() {
      const response = await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/atosa_agent/get_unpaid_cost', {
        shop_id: this.shop._id,
        current_time: this.dayjs().unix(),
      }, this.cf())
      this.atosa_agent_unpaid = response.body.data
    },

    m__convert_category_children(children) {
      if (children && Array.isArray(children) && children.length) {
        for (const child of children) {
          child.value = child.category_id
          child.label = child.display_name
          if (child.children && Array.isArray(child.children) && child.children.length) {
            this.m__convert_category_children(child.children)
          }
        }
      }
    },

    async m__get_categories() {
      const response = await this.sp_user.marketing_pas_get_category_tree()
      if (response && response.data && response.data && response.data.category_tree) {
        for (const item of response.data.category_tree) {
          item.value = item.category_id
          item.label = item.display_name
          this.m__convert_category_children(item.children)
        }

        this.cascader_options[1].children = response.data.category_tree
      }
    },

    async m__get_shop_categories() {
      const response = await this.sp_user.marketing_pas_get_page_active_collection_list()
      if (response && response.data && response.data.list) {
        for (const item of response.data.list) {
          item.value = item.id
          item.label = item.name
        }
        this.cascader_options[2].children = response.data.list
      }
    },

    async m__get_connect_erp_platform_login_url() {
      const resp = await this.$http.post('https://api.atosa.asia/api/v1/open-platform/', {
        name: '',
        channel: 'open_platform_shopee',
        redirect_url: `${window.location.origin}/shop`,
      }, this.cf())

      window.open(resp.body.data.url, '_blank')
    },

    async m__get_connect_ads_platform_login_url() {
      const response = await this.$http.post(this.API.URL_API_SRV_2 + '/ads_platform/get_login_url', {
        shop_id: this.shop.shop_id,
      }, this.cf())

      window.open(response.body.data.url, '_blank')
    },

    async m__set_set_smart_booster() {
      const form = {
        auto_budget_increase: {
          daily_cap: this.smart_booster.auto_budget_increase.daily_cap,
          effective_type_list: this.smart_booster.auto_budget_increase.effective_type_list,
          increment: this.smart_booster.auto_budget_increase.increment,
          is_on: this.auto_budget_increase_status
        },
        campaign_surge: {
          toggle_on: this.surge_setting_status
        }
      }
      await this.sp_user.marketing_set_smart_booster(form)
    },

    async m__set_surge_setting(status) {
      await this.sp_user.marketing_pas_set_surge_setting(status)
      this.surge_setting_status = status
    },

    async m__get_agency_file() {
      const send_request_list_resp = await this.$http.get(
        this.API.URL_API_SRV_2 + '/mipee/sub_account/send_request_list', this.cf())

      const mipeeUserIds = [
        this.$store.state.userInfo.username,
        ...send_request_list_resp.body.data.filter(i => i.status === 'accepted').map(i => i.request_user.username)].join(',')
      const resp = await this.$http.get(this.API.URL_API_SRV_1 + '/agency_file/list', {
        ...this.cf(),
        params: {
          mipeeUserId: this.$store.state.userInfo.username,
          mipeeUserIds,
        },
      })
      for (const item of resp.body) {
        item.loading = false
      }
      this.agency_files = resp.body.filter(
        i => this.$store.state.userInfo.username === 'vuducminhdev07' ? true : this.shopee_shop.list.some(
          ii => ii._id === i.shopId))
    },

    m__on_back_to_list() {
      this.current_component = 'list'
      this.m__initial_view(false)
    },

    async m__initial_view(load_product = true) {
      if (load_product) this.component_key = make_uuid()
      this.current_component = 'list'

      try {
        const shop = this.shopee_shop.list.find(i => i._id === this.shopee_shop.selected)
        if (!shop) return

        // todo: check role
        if (
          !this.check_role(shop, 'marketing', 'campaigns', false) &&
          !this.check_role(shop, 'keyword_ads', 'get_campaign', false) &&
          !this.check_role(shop, 'targeting_ads', 'get_campaign', false)
        ) {
          this.check_role(shop, 'marketing', 'campaigns')
          this.shopee_shop.selected = ''
          return
        }

        this.shop = shop
        this.sp_user = await this.init_seller(this.shop)

        if (!await this.check_shop(this.sp_user)) {
          this.shopee_shop.selected = ''
          return
        }

        const ads_data_response = await this.sp_user.marketing_pas_get_ads_data()
        this.ads_data = ads_data_response.data
        if (this.ads_data && this.ads_data.setup_flow_version.version === 'old') {
          await this.$router.push('/marketing?shop_id=' + this.shop.shop_id)
        }
        if (this.ads_data && this.ads_data.ads_credit) {
          this.balance = this.m__calculate(this.ads_data.ads_credit.total / 100000)

          if (this.ads_data.ads_credit.is_low_balance) {
            this.ntf_w(this.$t('ads.low_balance_message'))
          }
        }

        if (load_product) {
          const ads_config_response = await this.sp_user.marketing_pas_get_ads_config()
          this.ads_config = ads_config_response.data

          const non_ads_data_response = await this.sp_user.marketing_pas_get_non_ads_data()
          this.non_ads_data = non_ads_data_response.data

          // const surge_setting_response = await this.sp_user.marketing_pas_get_surge_setting()
          // this.surge_setting_status = surge_setting_response.data.toggle_on

          const smart_booster_response = await this.sp_user.marketing_get_smart_booster()
          this.smart_booster = smart_booster_response.data
          this.surge_setting_status = this.smart_booster.enabled.campaign_surge
          this.auto_budget_increase_status = this.smart_booster.enabled.auto_budget_increase
          this.smart_voucher_status = this.smart_booster.enabled.smart_voucher

          await Promise.all([
            this.m__get_categories(),
            this.m__get_shop_categories(),
          ])

          try {
            const ads_platform_response = await this.$http.post(
              this.API.URL_API_SRV_2 + '/ads_platform/check_connection', {
                shop_id: this.shop.shop_id,
              }, this.cf())
            this.is_connected_ads_platform = ads_platform_response.body.data.is_connected
          } catch (e) {
            // console.error(e)
          }

          if (!this.is_connected_ads_platform) {
            this.show_dialog.connected_ads_platform_required = true
          }

          this.m__get_shop_product_list().then(() => {
            this.selected_product_ids = []
            if (this.$route.query.product_ids && this.$route.query.product_ids.split(',').length) {
              this.selected_product_ids = this.$route.query.product_ids.split(',').map(i => +i)

              const query = {...this.$route.query}
              delete query.product_ids
              this.$router.replace({query})

              this.current_component = 'create'
            }
          })

          await this.m__get_current_atosa_agent_package()
          await this.m__get_unpaid_operating_cost()
          if (!this.unpaid_atosa_agent_showed_dialog && this.m__check_is_unpaid_operating_cost()) {
            await this.sleep(2000)
            // this.show_dialog.atosa_agent_unpaid = true
          }
        }

        this.allow_show_alert = true
      } catch (e) {
        console.error(e)
        this.ntf_w(this.$t('shop.connect_error'))
      }
    },

    async m__get_shop_product_list(use_cache = true) {
      const current_shop_id = this.shop._id

      this.loading.get_products = true
      this.product_list = []

      const cache_response = await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/cache/get_marketing_products', {
        shop_id: this.shop.shop_id,
      }, this.cf())

      const product_cache_list = cache_response && cache_response.body && cache_response.body.data &&
      cache_response.body.data.length
        ? typeof cache_response.body.data === 'string' ? JSON.parse(cache_response.body.data) : cache_response.body.data
        : []

      if (use_cache && product_cache_list.length > 300) {
        for (const i of product_cache_list) {
          i.id = i.itemid
          i.checked = false
          i.revenue = i.sold * i.price
          i.extra_data = {
            add_to_cart_units: 0,
            placed_units: 0,
            placed_sales: 0,
            sales: 0,
            orders: 0,
            rating: 0,
          }
          i.ads_list = []
        }

        this.product_list = product_cache_list
        this.loading.get_products = false

        console.log('loaded products from cache')
      } else {
        let offset = 0, limit = 50
        let product_resp = await this.sp_user.marketing_product_selector(offset, limit)

        while (product_resp && product_resp.data && product_resp.data.item_list && product_resp.data.item_list.length) {
          for (const i of product_resp.data.item_list) {
            i.id = i.itemid
            i.checked = false
            i.revenue = i.sold * i.price
            i.extra_data = {
              add_to_cart_units: 0,
              units: 0,
              sales: 0,
              orders: 0,
              rating: 0,
            }
            i.ads_list = []
          }

          if (current_shop_id !== this.shop._id) return

          this.product_list.push(...product_resp.data.item_list)
          offset += limit
          product_resp = await this.sp_user.marketing_product_selector(offset, limit)
        }
      }

      this.product_list = this.clone(_orderBy(this.product_list, ['revenue'], ['desc']))

      this.m__get_product_performance(this.sp_user).catch(console.error)

      this.loading.get_products = false
    },

    async m__get_product_performance(seller) {
      try {
        const cache_response = await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/cache/get_shopee_ads_products', {
          shop_id: this.shop.shop_id,
        }, this.cf())
        if (cache_response && cache_response.body && cache_response.body.data) {
          const product_cache_list = typeof cache_response.body.data === 'string'
            ? JSON.parse(cache_response.body.data)
            : cache_response.body.data

          for (const product of product_cache_list) {
            const product_found = this.product_list.find(i => i.itemid === product.item_id)
            if (product_found) product_found.extra_data.rating = parseFloat(product.rating.toFixed(1))
          }
        }

        let page = 1, page_size = 20
        const start_time = this.dayjs().subtract(30, 'days').startOf('d').unix()
        const end_time = this.dayjs().startOf('d').unix()
        let product_performance_resp = await seller.get_product_performance_main(page, page_size, start_time, end_time,
          'past30days')

        const performance_list = []
        while (seller && seller.username === seller.username &&
        product_performance_resp && product_performance_resp.data && product_performance_resp.data.result &&
        product_performance_resp.data.result.items && product_performance_resp.data.result.items.length) {

          performance_list.push(...product_performance_resp.data.result.items)
          if (performance_list.length > product_performance_resp.data.result.total) {
            break
          }

          for (const product of product_performance_resp.data.result.items) {
            const product_found = this.product_list.find(i => i.itemid === product.id)
            if (product_found) {
              product_found.extra_data.add_to_cart_units = product.add_to_cart_units || 0
              product_found.extra_data.orders = product.placed_units || 0
              product_found.extra_data.sales = seller.m__calculate(product.placed_sales)
            }
          }

          await this.sleep(1000)
          page++
          product_performance_resp = await seller.get_product_performance_main(page, page_size, start_time, end_time,
            'past30days')
        }
      } catch (e) {
        console.error(e)
      } finally {
        this.loading.get_product = false
      }
    },

    async m__change_date() {
      if (!this.date_range) return

      this.start_date = this.date_range[0]
      this.end_date = this.date_range[1]

      if (this.campaign_component === 'list') this.component_key = make_uuid()
      await this.m__initial_view(false)
    },

    m__show_select_hour_dialog() {
      this.show_dialog.select_hour = true
    },

    async m__select_add_campaign_type() {
      if (!this.check_role(this.shop, 'keyword_ads', 'create_campaign')) {
        return
      }

      this.loading.add_campaign_type = true
      try {
        if (!this.shopee_shop.selected) {
          this.ntf_w(this.$t('shop.select_for'))
          return
        }

        this.add_campaign_type = 'product'
        this.show_dialog.add_campaign_type = true
      } catch (e) {
        console.error(e)
      } finally {
        this.loading.add_campaign_type = false
      }
    },

    async m__redirect_add_campaign() {
      this.show_dialog.add_campaign_type = false
      this.current_component = 'create'
    },
  },
}
</script>

<style lang="scss">
.el-tooltip__popper {
  max-width: 600px;
}

.config-tab-active {
  background-color: #FDE0C8;

  label {
    color: #CF5400;
  }
}

.card-fixed {
  cursor: pointer;

  .el-card {
    border: 1px solid #e5e5e5;
  }
}

.card-fixed-active {
  cursor: pointer;

  .is-always-shadow {
    border-color: orangered;
  }
}

.card-fixed-inactive {
  cursor: not-allowed;

  * {
    color: #999;
  }
}

.scrollable {
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
}

.page__shopee-marketing {
  .btn--tab {
    border: 0;
    background-color: white;
    color: #3A3A3A;
    padding: 4px 10px;
    border-radius: 15px 15px 0 0;
    outline: 0;
    box-shadow: -2px -3px 4px rgba(45, 45, 48, .1);

    &:hover {
      color: orangered;
    }

    &.in-active {
      background-color: whitesmoke;
      box-shadow: unset;
    }
  }

  .text-auto {
    background: hsla(0, 0%, 60%, .12);
    padding: 4px;

    a {
      color: #999;
    }
  }

  .el-button .text-success {
    * {
      color: #3c763d !important;
    }
  }

  .text-warning {
    color: #8a6d3b !important;
  }

  .text-danger {
    color: #a94442 !important;
  }

  .hide-icon {
    i {
      display: none;
    }
  }

  .show-on-hover {
    i.el-icon-edit {
      display: none;
    }
  }

  .show-on-hover:hover {
    i.el-icon-edit {
      display: inline-block;
    }
  }
}

.hover-class:hover {
  border-bottom: 1px dashed #999;
}

.text-orange {
  span {
    color: orangered !important;
  }
}

.tab-active {
  border-bottom: 2px solid #409eff;
}

.chatbot-button {
  position: fixed;
  bottom: 14px;
  right: 24px;
  padding: 8px 12px;
  background-color: #8e44ad;
  color: white;
  border: none;
  border-radius: 25px;
  font-size: 13px; /* chữ nhỏ hơn */
  cursor: pointer;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.2);
  z-index: 2001;
  transition: transform 0.3s ease;
  outline: none;
  font-weight: 600;
}

.chatbot-button::before {
  content: '';
  position: absolute;
  top: -50%;
  left: -100%;
  width: 40%;
  height: 200%;
  background: rgba(255, 255, 255, 0.08);
  transform: rotate(25deg);
  filter: blur(3px);
  //animation: lightStreak 2.5s linear infinite;
  z-index: 1;
}

.chatbot-button::after {
  content: '';
  position: absolute;
  inset: 0;
  border-radius: 25px;
  border: 1px solid rgba(255, 255, 255, 0.15);
  z-index: 2;
}

@keyframes lightStreak {
  0% {
    left: -100%;
  }
  100% {
    left: 100%;
  }
}

.chatbot-button:hover {
  background-color: #732d91; /* tím đậm hơn khi hover */
}
</style>

<style>
.ai-welcome-dialog {
  width: 100%;
  margin: 0 auto;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  font-family: 'Arial', sans-serif;
  background: #fff;
}

/* Khung 1: Welcome */
.welcome-section {
  background-image: url('https://images.unsplash.com/photo-1508780709619-79562169bc64?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80');
  background-size: cover;
  background-position: center;
  position: relative;
  padding: 30px 20px;
  text-align: center;
  color: #333;
}

.welcome-section::after {
  content: '';
  display: block;
  background: rgba(255, 255, 255, 0.75);
  backdrop-filter: blur(3px);
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 0;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
}

.welcome-content {
  position: relative;
  z-index: 1;
}

.welcome-content h3 {
  margin-bottom: 12px;
  font-weight: bold !important;
  font-size: 25px !important;
}

.welcome-content p {
  font-size: 15px;
  font-weight: bold;
  margin-top: 30px;
  padding: 0 20px;
}

/* Khung 2: Danh sách chiến dịch */
.campaign-section {
  padding: 24px;
  text-align: left;
}

.campaign-section h3 {
  margin-bottom: 16px;
  font-size: 20px;
}

.campaign-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 15px;
  max-height: calc(100vh - 510px);
  overflow-y: scroll;
  padding-right: 20px;
}

.campaign-item {
  display: flex;
  align-items: center;
  gap: 20px;
  cursor: pointer;
}

.campaign-item img {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  object-fit: cover;
}

.campaign-name {
  font-size: 13px;
  color: #333;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1;
}

.start-button {
  padding: 8px 18px;
  background-color: #6a0dad;
  color: white;
  border: none;
  border-radius: 9999px;
  font-size: 13px;
  cursor: pointer;
}

.start-button:hover {
  background-color: #590bbf;
}

.payment-button {
  padding: 8px 18px;
  background-color: #ee4d2d;
  color: white;
  border: none;
  border-radius: 9999px;
  font-size: 13px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/pages/pas/index.vue